import { getApiUrl } from "@commons-monorepo/index";

export const getAdsStore = (country: string) => {
  return fetch(`${getApiUrl()}/api/ms/prime/ads/${country}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    } as HeadersInit,
  });
};
